import Button from './Button.js'

export default function CallToAction() {
    return (
        <section class="callToAction">
            <div>
                <Button path="/tutors-list-page" name="Search for Tutors" style="Button"/>
                <p class="Description-Medium">Meet our best tutors of all subjects today!</p>
            </div>
        </section>
    )
}